/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc.
// Written by Autodesk Design Automation team for Inventor
/////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'react-base-table/styles.css';
import './projectList.css';
import {
    updateActiveTabIndex,
    showModalProgress,
    invalidateDrawing
} from '../actions/uiFlagsActions';
import { setUploadProgressHidden, hideUploadFailed } from '../actions/uploadPackageActions';
import { updateActiveProject } from '../actions/projectListActions';
import UploadPackage from './uploadPackage';
import DeleteProject from './deleteProject';

import ModalProgressUpload from './modalProgressUpload';
import ModalProgress from './modalProgress';
import ModalFail from './modalFail';
import {
    uploadProgressShowing,
    uploadProgressIsDone,
    uploadPackageData,
    uploadFailedShowing,
    modalProgressShowing,
    errorData,
    getAdoptWarnings
} from '../reducers/mainReducer';
import CheckboxTable from './checkboxTable';
import { fullWarningMsg } from '../utils/conversion';

export class ProjectList extends Component {
    isDone() {
        return this.props.uploadProgressIsDone;
    }

    onProgressCloseClick() {
        this.props.setUploadProgressHidden();
    }

    onDeleteCloseClick() {
        this.props.showModalProgress(false);
    }

    onProjectClick(projectId) {
        this.props.updateActiveProject(projectId);
        this.props.invalidateDrawing();
        this.props.updateActiveTabIndex(1);
    }

    onProgressOpenClick() {
        this.props.setUploadProgressHidden();
        this.props.updateActiveProject(this.props.uploadProjectName);
        this.props.invalidateDrawing();
        this.props.updateActiveTabIndex(1);
    }

    onUploadFailedCloseClick() {
        this.props.hideUploadFailed();
    }

    render() {
        const showUploadProgress = this.props.uploadProgressShowing;

        return (
            <div className="tabContainer fullheight">
                {/* Ukryte przyciski upload i delete */}

                <div className="fullheight">
                    <CheckboxTable
                        onProjectClick={(id) => {
                            this.onProjectClick(id);
                        }}
                        selectable={false}
                    />
                </div>

                <UploadPackage />

                {showUploadProgress && (
                    <ModalProgressUpload
                        open={true}
                        title={this.isDone() ? 'Upload Finished' : 'Uploading package'}
                        label={this.props.uploadPackageData.file.name}
                        icon="Archive.svg"
                        onClose={() => {
                            this.onProgressCloseClick();
                        }}
                        onOpen={() => {
                            this.onProgressOpenClick();
                        }}
                        url={null}
                        isDone={() => this.isDone() === true}
                        warningMsg={this.isDone() ? this.props.adoptWarning : null}
                    />
                )}

                {this.props.uploadFailedShowing && (
                    <ModalFail
                        open={true}
                        title="Upload Failed"
                        contentName="Package:"
                        label={this.props.uploadPackageData.file.name}
                        onClose={() => this.onUploadFailedCloseClick()}
                        errorData={this.props.errorData}
                    />
                )}

                <DeleteProject />

                {this.props.modalProgressShowing && (
                    <ModalProgress
                        open={this.props.modalProgressShowing}
                        title="Deleting Project(s)"
                        label="Deleting project(s) and cache"
                        icon="/Assembly_icon.svg"
                        onClose={() => this.onDeleteCloseClick()}
                    />
                )}
            </div>
        );
    }
}

/* istanbul ignore next */
export default connect(function (store) {
    const filename = uploadPackageData(store)?.file?.name;
    const uploadProjectName =
        filename && filename.lastIndexOf('.') > 0
            ? filename.substring(0, filename.lastIndexOf('.'))
            : filename || null;

    const adoptWarning = fullWarningMsg(
        getAdoptWarnings(uploadProjectName, store)
    );

    return {
        uploadProgressShowing: uploadProgressShowing(store),
        uploadProgressIsDone: uploadProgressIsDone(store),
        uploadPackageData: uploadPackageData(store),
        uploadProjectName: uploadProjectName,
        uploadFailedShowing: uploadFailedShowing(store),
        errorData: errorData(store),
        modalProgressShowing: modalProgressShowing(store),
        adoptWarning: adoptWarning,
    };
},
    {
        updateActiveProject,
        updateActiveTabIndex,
        setUploadProgressHidden,
        hideUploadFailed,
        showModalProgress,
        invalidateDrawing,
    })(ProjectList);